<template>
  <Datepicker
    v-model="internalModel"
    inline
    auto-apply
    range
    model-type="yyyy-MM-dd"
    :multi-calendars="false"
    :enable-time-picker="false"
    :min-date="new Date()"
    locale="de"
    :shortcuts="false"
    no-input
    :partial-range="true"
    class="filter-item-date"
    @internal-model-change="handleInternalUpdate"
  />
  <div v-if="isResetVisible" class="flex justify-center">
    <Chip
      class="chip md:hidden! inline-flex"
      @click="handleInternalUpdate([], [], true)"
    >
      <div class="flex items-center gap-1">
        <span>{{ $t('search.buttons.clearCalendar') }}</span>
        <TrailingIcon />
      </div>
    </Chip>
  </div>
</template>
<script setup>
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import TrailingIcon from '~/assets/icons/trailing-icon.svg?component'

const model = defineModel()

const emit = defineEmits(['updated'])

const props = defineProps({
  selectedDates: {
    type: Array,
    default: () => [],
    required: false,
  },
})

const internalModel = ref([...(model.value || props.selectedDates || [])])

const isResetVisible = computed(() => {
  return internalModel.value.length > 0
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const handleInternalUpdate = (dates, value, isReset = false) => {
  // This will catch the value of the datepicker even when it has a single
  // date selected
  if (isReset) {
    internalModel.value = []
    model.value = []
    emit('updated', [])
    return
  }

  if (Array.isArray(value)) {
    // send first date as second if only 1 date selected
    emit('updated', [value[0], value[1] ? value[1] : value[0]])
  }
}
</script>
<style lang="css">
@reference '~/assets/css/tailwind.css';
.filter-item-date {
  @apply flex-col;
}

.filter-item-date > div {
  @apply border-none p-0 shadow-none mx-auto;
  @apply w-full;
}

.filter-item-date button {
  @apply py-0;
}

.dp__menu.dp__relative.dp__theme_light {
  @apply border-none;
  font-family: 'Lexend';
}

.dp__menu_inner.dp__flex_display .dp__instance_calendar:first-child {
  @apply pr-3;
}

.dp__menu_inner.dp__flex_display .dp__instance_calendar:last-child {
  border-left: 1px solid var(--dp-menu-border-color);
}

.dp__today {
  border-color: #032e32;
}

.dp__range_end,
.dp__range_start,
.dp__active_date {
  background-color: #032e32;
}

button.vtd-datepicker-date {
  @apply w-6 h-[1.5rem];
}
</style>
